{ "imageTag": "20261105110227_6e40e2d", "buildUri": "vstfs:///Build/Build/104369", "buildId": "104369", "sourceCommit": "6e40e2d568b6cd22432636a26d226ecf5bdfc43e", "sourceBranch": "main", "releaseDate": "2026-11-05T11:14:22Z" }
